import { GET_ETOLL_SENT_CHECK_DEVICE } from '../actions/types';
import isEmpty from '../validation/is-empty';

const initialState = {
  list: []
}

export default function(state = initialState, action ) {
    switch(action.type) {
        case GET_ETOLL_SENT_CHECK_DEVICE:
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}
